import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";

import Rating from "@material-ui/lab/Rating";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { adjective as clientAdjective } from "@language/client";

const { SITE_NAME } = process.env;

const WebsiteBanner = ({}) => {
	const classes = useStyles("Website");

	const heroSize = {
		xs: 200,
		s: 340,
		m: 480,
		l: 620,
		xl: 750,
	};

	const heroPicture =
		"https://images.babylist.com/image/upload/f_auto,q_auto:best,c_scale,w_768/v1676577929/hello-baby/8_signs_great_daycare_header.jpg";

	const heroContained = false;

	const header = `Let us turn your yard into a resort-like oasis`; // GPT / write one short headline, max 5 words {profile blob and biz info / services offered}
	const subHeader = `Give them a strong start for the learning journey ahead.`;
	const tagline = "Austin daycare & preschool";
	const textAlign = "left"; // left / center / right
	const video = false;
	const videoUrl = "//static.tutors.com/assets/images/misc/1077583892-hd.mp4";

	const showButtons = true;
	const showReviews = true;

	const primaryButton = "Book now";
	const secondaryButton = "Get a quote";

	//const youtubeEmbedUrl = `https://www.youtube.com/embed/2QSukL7dl5o?controls=0&autoplay=1&loop=1&mute=1&modestbranding=1&rel=0`;

	const youtubeEmbedUrl = "";

	const replaceSize = (src, size) => src.replace("{SIZE_REPLACE}", size);

	return (
		<React.Fragment>
			<Box
				component={"section"}
				minHeight={heroSize.xl}
				className={classes.hero}
			>
				{video ? (
					<>
						{youtubeEmbedUrl ? (
							<>
								<div
									className="video-responsive"
									style={{
										//position: "relative",
										width: "100%",
										height: "100%",
										overflow: "hidden",
										// paddingBottom: "56.25%",
										// height: 0,
									}}
								>
									<iframe
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											width: "100%",
											height: "100%",
											minWidth: "100vw",
											minHeight: "100vh",
											pointerEvents: "none",
											//objectFit: "cover",
										}}
										src={youtubeEmbedUrl}
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
										title="Embedded YouTube Video"
									/>
								</div>
							</>
						) : (
							<Box
								height={"100%"}
								width={"100%"}
								overflow={"hidden"}
								className={classes.picture}
							>
								<video
									id="earth"
									preload="auto"
									autoPlay={true}
									loop={true}
									muted={true}
									style={{ minWidth: "100vw", minHeight: "100vh" }}
								>
									<source src={videoUrl} type="video/mp4" />
								</video>
							</Box>
						)}
					</>
				) : (
					<picture className={classes.picture}>
						<source
							srcSet={`${replaceSize(
								heroPicture,
								"h_200,w_400"
							)} 400w, ${replaceSize(
								heroPicture,
								"h_400,w_768"
							)} 768w, ${replaceSize(heroPicture, "w_1200")} 1200w`}
							sizes="100vw"
						/>
						<img
							sizes="100vw"
							srcSet={`${replaceSize(
								heroPicture,
								"h_200,w_400"
							)} 400w, ${replaceSize(
								heroPicture,
								"h_400,w_768"
							)} 768w, ${replaceSize(heroPicture, "w_1200")} 1200w`}
							src={replaceSize(heroPicture, "w_1200")}
							alt={`Find a as`}
							className={classes.backgroundImage}
							fetchpriority="high"
						/>
					</picture>
				)}

				<Container maxWidth="lg" disableGutters>
					<Box width="100%" left={0} top="50%" className={classes.heroBox}>
						<Box
							borderRadius={12}
							boxShadow={heroContained ? 5 : 0}
							className={heroContained ? classes.heroBoxContent : undefined}
							maxWidth={heroContained ? 600 : "10)%"}
						>
							{tagline && (
								<>
									{heroContained ? (
										<div className="tagline">{tagline}</div>
									) : (
										<Box
											textAlign={textAlign}
											style={{
												textTransform: "uppercase",
												textShadow: "rgb(68 68 68) 2px 2px 12px",
											}}
											letterSpacing={3}
											color={"#FFFFFF"}
											fontSize={{ xs: 16, sm: 16 }}
											fontWeight={600}
											m={0}
										>
											{tagline}
										</Box>
									)}
								</>
							)}

							{header && (
								<Box
									component={"h1"}
									fontSize={
										heroContained ? { xs: 40, sm: 52 } : { xs: 46, sm: 64 }
									}
									color={heroContained ? "#222" : "#FFFFFF"}
									fontWeight={600}
									textAlign={textAlign}
									style={{
										textShadow: heroContained
											? "unset"
											: "rgb(68 68 68) 2px 2px 12px",
									}}
									mb={4}
									lineHeight={1.2}
								>
									{header}
								</Box>
							)}

							{subHeader && (
								<Box
									fontWeight={600}
									textAlign={textAlign}
									color={heroContained ? "#222" : "#FFFFFF"}
									fontSize={
										heroContained ? { xs: 18, sm: 22 } : { xs: 20, sm: 24 }
									}
									lineHeight={1.5}
									style={{
										textShadow: heroContained
											? "unset"
											: "rgb(68 68 68) 2px 2px 12px",
									}}
								>
									{subHeader}
								</Box>
							)}

							{showButtons && (
								<Box
									display={"flex"}
									alignItems={"center"}
									style={{ gap: 20 }}
									justifyContent={textAlign}
									my={10}
									flexDirection={{ xs: "column", sm: "row" }}
								>
									<Button
										size="large"
										color={"primary"}
										variant="contained"
										disableElevation
										href="/website/book"
										endIcon={<ArrowForwardIcon />}
										className={
											heroContained
												? classes.heroButtonContained
												: classes.heroButton
										}
									>
										{primaryButton}
									</Button>
									<Button
										variant="outlined"
										color="secondary"
										disableElevation
										href="tel:8888888888"
										size="large"
										//endIcon={<ArrowForwardIcon />}
										className={
											heroContained
												? classes.heroButtonContained
												: classes.heroButton
										}
									>
										{secondaryButton}
									</Button>
								</Box>
							)}

							{showReviews && (
								<Box
									display={"block"}
									color={heroContained ? "#222" : "#FFFFFF"}
									fontWeight={600}
								>
									<Box
										display={"flex"}
										alignItems={"center"}
										fontSize={{ xs: 14, sm: 16 }}
										component={"a"}
										justifyContent={textAlign}
										href="#reviews"
										style={{
											gap: 12,
											textShadow: heroContained
												? "unset"
												: "rgb(68 68 68) 2px 2px 12px",
										}}
									>
										<div>{`${clientAdjective.plural.ucFirst()} rate us 4.7`}</div>
										<Rating
											name="read-only"
											value={4.5}
											precision={0.5}
											readOnly
											classes={{
												iconFilled: heroContained
													? classes.ratingRootContained
													: classes.ratingRoot,
											}}
										/>
										<div>119+ reviews</div>
									</Box>
								</Box>
							)}
						</Box>
					</Box>
				</Container>

				{/* <Box
					display={"block"}
					position="absolute"
					textAlign="right"
					color="#FFF"
					fontSize={14}
					fontWeight={600}
					p={6}
					bottom={0}
					right={0}
				>
					<Box display={"flex"} alignItems={"center"} style={{ gap: 12 }}>
						<div>{`${clientAdjective.plural.ucFirst()} rate us 4.7`}</div>
						<Rating
							name="read-only"
							value={4.5}
							precision={0.5}
							readOnly
							classes={{ iconFilled: classes.ratingRoot }}
						/>
						<div>119+ reviews</div>
					</Box>
				</Box> */}
			</Box>
		</React.Fragment>
	);
};

WebsiteBanner.propTypes = {};

export default WebsiteBanner;
